module.exports = __webpack_public_path__ + "img/jiaoyingzi1.c1cc40a7.png";